import React, { useContext, useEffect, useState } from 'react';
import EmployeeContext from '../../../utils/EmpDetails/EmployeeProvider';
import { decryptPII } from '../../../utils/encryption/aesEncryption';
import { ticketIssue } from '../../../services/weberpservice';
import { getAssigneeDetails, nachDetails, ctcActivity } from '../../../services/merpservices';
import NachStop from './Nachstop/NachStop';
import FileUpload from './FileUpload';
import { TicketTagging } from '../../Ticket/TicketTagging';
import { gaEvent } from '../../../utils/GoogleAnalytics/gatracking';
import { Alert } from '../../../utils/Alert';
import {maskMobileNumber} from '../../../utils/Misc/maskMobileNumber'
import { useGlobalContext } from '../../../SearchBar/SearchBar';
import filterWipTickets from './filterWipTickets';
import { fetchTicketData } from '../../Ticket/FetchTicketDetails';
import { isTeleMVertical } from '../../../utils/verticalUtils';
import { handleCreateTicket } from './handleCreateTicket';
import { handleTicketClosure } from './handleTicketClosure';
import { updateSTSHistory } from "../../../services/merpservices";
const ocr_templates = require('./OcrTemplates.json');

const OcrTemplates = ({
    empid,
    ak,
    glid,
    dispId = -1,
    // custId,
    screen = null,
    Glid_def = null,
    descId = null,
    selectedAccountRelatedTab,
    isDispSet = null,
    history,
    ticketId = null,
    ticketType = null,
    ticketCount = null,
    isDocReceivedCheckBox,
    complaintDetails,
    refreshTicketDetails
}) => {
    const employeeDetails = useContext(EmployeeContext)
    const { custId, verticalId, stsId: stsID } = useGlobalContext();
    const [templateIds, setTemplateIds] = useState([]);
    const [templates, setTemplates] = useState({});
    const [comments, setComments] = useState('');
    const [attachmentPath, setAttachmentPath] = useState('');
    const [uploadedFileNames, setUploadedFileNames] = useState('');
    const [disableTktBtn, setDisableTktBtn] = useState(false);

    const teleMVertical = ["22", "35", "37", "40"];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = ocr_templates;
                setTemplateIds(data.dispositions[dispId] || []);
                setTemplates(data.templates || {});
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [glid]);

    useEffect(()=>{
        if(selectedAccountRelatedTab === "46"){
            getNACHDetails(glid);
        }
    }, [selectedAccountRelatedTab])

    const [getNACHData, setGetNACHData] = useState([]);

    const getNACHDetails = async (glid) => {
        try {
            const res = await nachDetails(employeeDetails?.empid, employeeDetails?.ak, glid);
            setGetNACHData(res?.data);
        } catch (error) {
            console.log(error)
        }
    }

    const gaEventForQuickLink = {
        "Registration Done": "Registration Done",
        "Interested in Paid Service": "Interested in Paid Services",
        "Guided on disable account": "Guided on Disable Account",
        "Add/Delete Product": "Add/Delete Product",
        "Account Status. 24-48 Hours wait": "Account Status",
        "Catalog Status": "Catalog Status"
    };

    const applyQuickTemplate = (template) => {
        setComments(template?.content);
        const eventLabel = gaEventForQuickLink[template?.shorthand];
        if (eventLabel) {
            gaEvent("Comments Single Click Chips", eventLabel, "click", `${eventLabel} Chip Button`, glid);
        }
    };

    const handleCommentsChange = (event) => {
        setComments(event.target.value);
    };

    const handleTicketOpened = () => {
        // Ticket opened successfully or OCR, refresh ticket details
        refreshTicketDetails();
    };

    const OcrTicket = async (params, flag=false, ticketId="") => {
        try {
            const res = await ticketIssue(params);
            if (res?.data['100'] === "OCR Ticket Added.") {
                await ctcActivity(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 4); // 4 Update STS
                alert("OCR has been completed");
                history();
                handleTicketOpened();
            } else if (res?.data && (res?.data["200"] && res?.data["200"] !== "") && (res?.data["300"] && res?.data["300"] !== "")) {
                await ctcActivity(employeeDetails?.empid,employeeDetails?.ak, crtObjId, 5); // 5 Open Ticket
                alert("Ticket opened Successfully..!!!")
                if (window.location.pathname === '/api/bsconflict') {
                    window.parent.document.getElementById('myModal').style.display = 'none';
                }
                handleTicketOpened();
            } else if (res?.data && (res?.data["200"] && res?.data["200"] !== "")) {
                await ctcActivity(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 6); // 6 Update Ticket
                flag ?  alert(`Details added successfully in existing WIP Ticket - ${ticketId}`) :  alert("Ticket updated Successfully..!");
                handleTicketOpened();
                history();
            } else if(res?.data['-1']){
                alert(`${res?.data['-1']}...!!!`);
            } else {
                alert("Error in Ticket processing..!")
            }
        } catch (error) {
            console.log(error);
        }
    }
    const url = new URL(document.location.href);
    const crtObjId = url.searchParams.get('crtObjectId');
    const source = url.searchParams.get('source');
    // Decrypt phone parameters (supports both encrypted and unencrypted for backward compatibility)
    const phone = decryptPII(url.searchParams.get('phone'));
    const origNum = decryptPII(url.searchParams.get('origNum'));

    const getAttachmentPath = (path) => {
        setAttachmentPath(path)
    }

    const getEmpDetail = async (tkt_id, stsid, tktCnt, escLevel, skipEscalationArray, check) => {
        try {
            const response = await getAssigneeDetails(employeeDetails?.empid, employeeDetails?.ak, tkt_id, stsid, check);

            // Check for successful response
            if (response.status === 200) {
                const dataHash = response.data;

                if (dataHash.status !== 200) {
                    console.log(dataHash.message);
                } else {
                    let teleemp = null;
                    let ccmails = '';

                    // Handle teleemp based on check value
                    if (dataHash.data.assigneedetails[0].TELEEMPID && check === 2) {
                        teleemp = dataHash.data.assigneedetails[0].TELEEMPID;
                    } else if (dataHash.data.assignedto && check === 1) {
                        teleemp = dataHash.data.assignedto;
                    }

                    // Construct ccmails
                    const empHicyArrayCnt = dataHash.data.emptrail.length;
                    for (let i = 0; i < tktCnt + escLevel && i < empHicyArrayCnt; i++) {
                        if (!skipEscalationArray.includes(dataHash.data.emptrail[i].EMPLOYEEID)) {
                            ccmails += `${dataHash.data.emptrail[i].EMAIL},`;
                        }
                    }

                    // Remove trailing commas
                    ccmails = ccmails.replace(/,+$/, '');
                    return ccmails;
                }
            } else {
                console.error('Error in fetching data:', response.statusText);
            }
        } catch (error) {
            console.error('Error:', error);
        }
        return '';
    }
    
    const clearCommentsAndAttachment = () => {
        setComments("");
        setAttachmentPath("");
    }


    const updateTicket = async (tktId, ticketIdCount, flag) => {
        if (!isDispSet || isDispSet !== 'set') {
            alert('Kindly fill the disposition first');
            return;
        } else if (!comments) {
            alert("Please enter comment here to update ticket");
            return;
        } else if(comments.length > 4000){
            alert("Please write comment within 4000 characters");
            return
        }else {
            ticketCount = (ticketCount||ticketIdCount === "0") ? "1" : ticketCount ?? ticketIdCount;
            let ccSubject = `HIGH PRIORITY - E${ticketCount}`;
            let ccmails = '';

            if (custId === 1) {
                if (glid && ticketType === "Buyer-Supplier Conflicts" && ticketId) {
                    ccmails = await getEmpDetail(ticketId, stsID, ticketCount, 1, [1, 23739], 1);
                } else if (ticketId) {
                    ccmails = await getEmpDetail(ticketId, stsID, ticketCount, 2, [1, 23739, 47805], 2);
                }
            }
            ccmails += ',buyersconnect@indiamart.com';
            let callComments
            if (crtObjId) {
                callComments = `${crtObjId}~~Received a call from ${maskMobileNumber(origNum || phone)}... ${comments}`
            }

            const params = {
                TicketId: ticketId ?? tktId,
                StsId: stsID,
                UserId: employeeDetails?.empid,
                LoginName: employeeDetails?.EMPLOYEENAME,
                CompId: "",
                Comments: crtObjId ? (attachmentPath ? `${callComments}\n${attachmentPath}` : callComments) : (attachmentPath ? `${comments}\n${attachmentPath}` : comments), // Ticket History Update with Call Details(ucid, callernumer) while append
                FlagType: 'Appendum',
                TicketType: 'General',
                LoginEmailId: employeeDetails?.EMAIL,
                MailCC: ccmails.replace(/(^\s*,)|(,\s*$)/g, ''),
                Subject: ccSubject,
                stsupdateemailfrom: '9696@intermesh.net',
                emailfromname: employeeDetails?.EMPLOYEENAME,
                AK: ak,
            };
            await OcrTicket(params, flag, ticketId ?? tktId);
            clearCommentsAndAttachment();
        }
    }

    const updateSTS = async (val) => {
        try {
            if (!isDispSet || isDispSet !== 'set') {
                alert('Kindly fill the disposition first');
                return;
            }
            let params;
            let callComments = '';
            let SourceName = '';
            let SourceType;
            const number = origNum || phone;
            let pay = ''
            let payment_id = ''
            let payment_id1 = ''
            let payment_id2 = ''
            let stsUpdateFrom = '9696@intermesh.net';
            let stsUpdateFromName = `${employeeDetails?.EMPLOYEENAME}`
            if (comments === '') {
                alert(`Please enter comment here to ${val}...`);
                return
            }
    
            if(comments.length > 4000){
                alert("Please write comment within 4000 characters");
                return
            }
    
            if (crtObjId) {
                callComments = `${crtObjId}~~Received a call from ${maskMobileNumber(number)}..${pay} ${payment_id} ${payment_id1} ${payment_id2}  ${comments}`;
                SourceName = '9696-Call Center';
                SourceType = 3;
            } else {
                if (source === "chat") {
                    SourceName = 'chat';
                    SourceType = 22;
                } else {
                    SourceName = 'Mails';
                    SourceType = 4;
                }
            }
            setDisableTktBtn(true);
            let bscomplaintDetails="";
            if (screen === "bsconflict") {
                const { product_name, dispute_amount, payment_mode, complaint_type } = complaintDetails;
                if (isNaN(dispute_amount) || dispute_amount < 0) {
                    Alert("Please enter a valid dispute amount.");
                    return;
                }
                bscomplaintDetails = `Product Name: ${product_name} \nDispute Amount: ${dispute_amount} \nMode of Payment:${payment_mode} \nComplainant Company: ${complaint_type} ` ?? ""
            }

            if (val === "STS Update") {
                await ctcActivity(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 23);
                updateSTSHistory(employeeDetails?.empid, employeeDetails?.ak, comments, glid, employeeDetails?.EMAIL, employeeDetails?.EMPLOYEENAME);
                alert("STS has been updated");
                history();
                handleTicketOpened();
                gaEvent("Update STS New Button", "Update STS New", "click", "Update STS New", glid);
                return;
            }
            else if (val === 'update STS') {
                if(isTeleMVertical(verticalId) && ["24", "47"].includes(selectedAccountRelatedTab)){
                   const createRes  = await handleCreateTicket({
                          empid: employeeDetails?.empid,
                          AK: employeeDetails?.ak,
                          glid: glid,
                          modid: 9696,
                          comment: crtObjId ? (attachmentPath ? `${callComments}\n${bscomplaintDetails}\n${attachmentPath}` : `${callComments}\n${bscomplaintDetails}`) : (attachmentPath ? `${comments}\n${bscomplaintDetails}\n${attachmentPath}` : `${comments}\n${bscomplaintDetails}`),
                          typeid: 199,
                          groupid: 15,
                          flag: "ocr",
                          source_id: SourceType
                        });
                    if (createRes.success) {
                        const closureParams = {
                            ticketId: createRes.ticketId,
                            ticketTypeid: createRes.ticketTypeid,
                            employeeDetails: employeeDetails,
                            tktComments:crtObjId ? (attachmentPath ? `${callComments}\n${bscomplaintDetails}\n${attachmentPath}` : `${callComments}\n${bscomplaintDetails}`) : (attachmentPath ? `${comments}\n${bscomplaintDetails}\n${attachmentPath}` : `${comments}\n${bscomplaintDetails}`),
                            tickets_clousers_id: 1096,
                            tickets_clousers_id1: 897,
                            tickets_clousers_id2: selectedAccountRelatedTab === "24" ? 1226 : 3515,
                            showAlert: true,
                            crtObjId: crtObjId,
                        };
                        await handleTicketClosure(closureParams);
                        history();
                        handleTicketOpened();
                        return ;
                    }
                }else{
                    params = {
                        StsId: stsID,
                        UserId: employeeDetails?.empid,
                        LoginName: employeeDetails?.EMPLOYEENAME,
                        CompId: "",
                        Comments: crtObjId ? (attachmentPath ? `${callComments}\n${bscomplaintDetails}\n${attachmentPath}` : `${callComments}\n${bscomplaintDetails}`) : (attachmentPath ? `${comments}\n${bscomplaintDetails}\n${attachmentPath}` : `${comments}\n${bscomplaintDetails}`),
                        SourceName: SourceName,
                        SourceType: SourceType,
                        FlagType: 'IssUe',
                        TicketType: 'OCr',
                        LoginEmailId: employeeDetails?.EMAIL,
                        MailCC: "",
                        CategoryId: 799,
                        CategoryName: "Service Related",
                        ReasonCodeId: 1096,
                        ReasonCodeName: "No Issue",
                        ActionTakenId: 897,
                        ActionTakenName: "No Action Taken",
                        stsupdateemailfrom: stsUpdateFrom,
                        emailfromname: stsUpdateFromName,
                        AK: employeeDetails?.ak
                    }
                }
                gaEvent("Update STS Button", "Update STS for On Call/ Mail resolution", "click", "Update STS for On Call/ Mail resolution", glid);
            } else {
                let ccmails = ''
                let ccSubject = ''
                let buyerDescId = ['368', '369', '370', '371', '372', '373', '374'];
                let bsflag = 'B';
                if (buyerDescId.includes(descId)) {
                    bsflag = 'B';
                } else {
                    bsflag = 'S';
                }
                if (screen === "bsconflict") {
                    params = {
                        StsId: stsID,
                        UserId: employeeDetails?.empid,
                        LoginName: employeeDetails?.EMPLOYEENAME,
                        CompId: '',
                        Comments: attachmentPath ? `${comments}\n${attachmentPath}\n${bscomplaintDetails}` : `${comments}\n${bscomplaintDetails}`,
                        SourceName: SourceName,
                        SourceType: SourceType,
                        FlagType: 'issuetagging',
                        TicketType: 'General',
                        RESPONDENT_GLUSRID: Glid_def,
                        LoginEmailId: employeeDetails?.EMAIL,
                        MailCC: '',
                        Subject: '',
                        stsupdateemailfrom: stsUpdateFrom,
                        emailfromname: stsUpdateFromName,
                        AK: employeeDetails?.ak,
                        BSConflict_TicketFlag: isDocReceivedCheckBox ? 'Yes' : 'No',
                        Complainant_Type: bsflag,
                        GroupId: 3,
                        TypeId: isDocReceivedCheckBox ? 181 : 306
                    }
                    gaEvent("Open New Ticket Button", "Open New ticket BSConflict", "click", "Open New ticket BSConflict", glid);
                } else {
                    let tagging_arr = await TicketTagging(descId, employeeDetails?.empid, glid, custId, '', 'WIP', employeeDetails?.ak, 1);
                    let group_id = tagging_arr[0];
                    let type_id = tagging_arr[1];
                    const data = await fetchTicketData(employeeDetails.empid, employeeDetails.ak, glid, '&check=wip');
                    // Extract all wip Tickets
                    const extractWIPTicketDetails = (data, group_id, type_id, type1, type2) => {
                        return filterWipTickets(data?.ticketData, group_id, type_id, type1, type2) || {};
                    };
                    // Creating params to pass in ticket api
                    const createParams = (ticketId, group_id, type_id, comments, flagType = "tagging", Complainant_Type="") => {
                        const params = {
                            StsId: stsID,
                            UserId: employeeDetails?.empid,
                            LoginName: employeeDetails?.EMPLOYEENAME,
                            CompId: "",
                            Comments: comments,
                            TicketId: ticketId || "",
                            GroupId: group_id,
                            TypeId: type_id,
                            FlagType: flagType,
                            TicketType: "General",
                            LoginEmailId: employeeDetails?.EMAIL,
                            MailCC: ccmails,
                            SourceName: SourceName,
                            SourceType: SourceType,
                            AK: employeeDetails?.ak,
                            Subject: ccSubject,
                            stsupdateemailfrom: stsUpdateFrom,
                            emailfromname: stsUpdateFromName,
                            ...(flagType === "tagging" && { Apppendum: comments }),
                            ...(Complainant_Type && { Complainant_Type: bsflag }),
                        };
                        return params;
                    };
    
                    const processTicket = async (ticketDetails, group_id, type_id, Complainant_Type) => {
                        const { FK_IIL_CUSTOMER_TICKETS_ID: ticketId = "", MAIL_SENT_COUNTER: ticketIdCount = "", FK_GROUP_ID, FK_TYPE_ID } = ticketDetails[0] ?? ticketDetails ;
                        const typeIds = ticketDetails.length > 1
                        ? ticketDetails.map(ticket => ticket.FK_TYPE_ID)
                        : [];
                        const comment = crtObjId ? (attachmentPath ? `${callComments}\n${attachmentPath}` : callComments) : (attachmentPath ? `${comments}\n${attachmentPath}` : comments);
                        if(teleMVertical.includes(verticalId) && ["429", "450"].includes(descId) && type_id !== "181"){
                            if(descId === "429"){
                                if(FK_GROUP_ID === "2"){
                                    if((group_id === FK_GROUP_ID && FK_TYPE_ID === "312")) {
                                        updateTicket(ticketId, ticketIdCount, true);
                                    }else if(group_id === FK_GROUP_ID && type_id !== FK_TYPE_ID) {
                                        params = createParams(ticketId, group_id, "312", comment);
                                    }else{
                                        params = createParams(ticketId, group_id, "312", comment);
                                    }
                                }else{
                                    params = createParams("", group_id, "312", comment, "issuetagging", Complainant_Type);
                                }
                            } else if(descId === "450"){
                                const hasDT  = "194" // DT_GROUP_ID = 194 (Service Deactivation)
                                const hasRefund = "312" // REFUND_GROUP_ID = 312 (Refund)
                                if(FK_GROUP_ID === "2"){
                                    // Step 1: Group by FK_IIL_CUSTOMER_TICKETS_ID and collect FK_TYPE_IDs
                                    const grouped = ticketDetails.reduce((acc, ticket) => {
                                    const id = ticket.FK_IIL_CUSTOMER_TICKETS_ID;
                                    acc[id] = acc[id] || [];
                                    acc[id].push(ticket.FK_TYPE_ID);
                                    return acc;
                                    }, {});

                                    // Step 2: Find IDs having both 194 and 312
                                    const matchedIDs = Object.entries(grouped)
                                    .filter(([_, typeIds]) => typeIds.includes('194') && typeIds.includes('312'))
                                    .map(([id]) => id);

                                    if(matchedIDs.length > 0){
                                        updateTicket(matchedIDs[0], ticketIdCount, true);
                                    }else if(FK_TYPE_ID === hasDT && FK_TYPE_ID !== hasRefund){
                                        params = createParams(ticketId, group_id, hasRefund, comment);
                                    }else if(FK_TYPE_ID === hasRefund && FK_TYPE_ID !== hasDT){
                                        params = createParams(ticketId, group_id, hasDT, comment);
                                    }else if(FK_TYPE_ID === hasDT && FK_TYPE_ID === hasRefund){
                                        updateTicket(ticketId, ticketIdCount, true); 
                                    }else if(FK_TYPE_ID !== hasDT && FK_TYPE_ID !== hasRefund){
                                        const paramDT = createParams(ticketId, group_id, hasDT, comment);
                                        const paramhasRefund = createParams(ticketId, group_id, hasRefund, comment);
                                        await ticketIssue(paramDT);
                                        await OcrTicket(paramhasRefund, true, ticketId);
                                    }

                                }else{
                                    params = createParams("", group_id, `${hasDT},${hasRefund}`, comment, "issuetagging", Complainant_Type);
                                }
                            }
                        }else if (ticketId) {
                            if(FK_GROUP_ID === "2"){
                                if ((group_id === FK_GROUP_ID && type_id === FK_TYPE_ID)) {
                                    updateTicket(ticketId, ticketIdCount, true);
                                }else if(group_id === FK_GROUP_ID && type_id !== FK_TYPE_ID) {
                                    if(typeIds.includes(type_id)){
                                        updateTicket(ticketId, ticketIdCount, true);
                                    }else{
                                        params = createParams(ticketId, group_id, type_id, comment);
                                    }
                                }else{
                                    params = createParams("", group_id, type_id, comment, "issuetagging", Complainant_Type);
                                }
                            }else if(FK_GROUP_ID === "3") {
                                if (type_id === "306") {
                                    updateTicket(ticketId, ticketIdCount, true);
                                }else{
                                    params = createParams("", group_id, type_id, comment, "issuetagging", Complainant_Type);
                                }
                            }else if(FK_GROUP_ID === "11") {
                                if ((group_id === FK_GROUP_ID && type_id === FK_TYPE_ID)) {
                                    updateTicket(ticketId, ticketIdCount, true);
                                }else{
                                    params = createParams("", group_id, type_id, comment, "issuetagging", Complainant_Type);
                                }
                            }
                        } else {
                            if(Complainant_Type){
                                params = createParams("", group_id, type_id, comment, "issuetagging", Complainant_Type);
                            } else{
                                params = createParams("", group_id, type_id, comment, "issuetagging");
                            }
                        }
                    };
    
                    if (["53", "54"].includes(selectedAccountRelatedTab)) {
                        const ticketDetails = extractWIPTicketDetails(data, group_id, type_id, 306, 181);
                        processTicket(ticketDetails, "3", "306", bsflag);
                    } else {
                        const ticketDetails = extractWIPTicketDetails(data, group_id, type_id);
                        processTicket(ticketDetails, group_id, type_id);
                    }
                    
                    gaEvent("Open New Ticket Button", "Open New ticket", "click", "Open New ticket", glid);
                }
            }
            if(params){
                await OcrTicket(params, true, params?.TicketId);
            }
            clearCommentsAndAttachment();
            getUploadedFiles({})
        } catch (error) {
            console.error("Error in updateSTS:", error);
        }finally{
            setDisableTktBtn(false);
        }
    }

    const getUploadedFiles = (files) => {
        let file_list = files[0]?.name
        setUploadedFileNames(file_list);
    }
        
    const paidCustArray = [1, 2, 7, 10, 12, 13, 15, 31, 48];
    const isPaidCustomer = paidCustArray.includes(parseInt(custId));

    return (
        <>
        {
            (screen === "bsconflict")
            ? 
                <div className="bs-middle">
                    <textarea
                        placeholder="Please enter additional comment ..."
                        className="comment-box"
                        rows="7"
                        value={comments}
                        onChange={handleCommentsChange}
                    />
                    {uploadedFileNames && <div className='uploaded-files'>{uploadedFileNames}</div>}
                    <div className="div-buttons">
                        <FileUpload glid={glid} getAttachmentPath={getAttachmentPath} getFiles={getUploadedFiles}/>
                        <button type="button" id='updateSTS' className='pd5 brd-none white-Color bg-Color bs-buttons cp' style={{ cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("update STS")}>OCR</button>
                        <button type="button" id='openTicket' className='pd5 brd-none white-Color bg-Color bs-buttons cp' style={{ cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("Open Ticket")}>Open Ticket</button>
                        <button type="button" id='updateSTS' className='pd5 brd-none white-Color bg-Color bs-buttons cp' style={{ cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("STS Update")}>Update STS</button>
                    </div>
                </div>
            :
            (screen === 'ticket-popup')
            ?
                <div className="col-41">
                    <div className="comment-box">
                        <textarea placeholder="Please enter comment ..." className="col-12" rows="5"
                            value={comments}
                            onChange={handleCommentsChange}
                            style={{width: '92%'}}
                        ></textarea>
                        {uploadedFileNames && <div className='uploaded-files'>{uploadedFileNames}</div>}
                        <div className="comment-btn1">
                            <FileUpload glid={glid} getAttachmentPath={getAttachmentPath} getFiles={getUploadedFiles}/>
                            <button className="pd5 brd-none white-Color bg-Color bs-buttons cp" onClick={() => updateTicket()}>Update Ticket</button>
                        </div>
                        <div className="quick_disp_template1">
                            {
                                templateIds.slice(0, 8).map((templateId) => {
                                    const template = templates[templateId];
                                    if (template) {
                                        return (
                                            <p
                                                key={template.id}
                                                onClick={() => applyQuickTemplate(template, true)}
                                                title={template.content}
                                                style={{ width: '43%' }}
                                            >
                                                <>{template.shorthand}</>
                                            </p>
                                        );
                                    }
                                    return null;
                                })
                            }
                        </div>
                    </div>
                </div>
            :
                <div className="col-41">
                    <div className="comment-box">
                        <textarea placeholder="Please enter comment ..." className="col-12" rows="5"
                            value={comments}
                            onChange={handleCommentsChange}
                        ></textarea>
                        {((isPaidCustomer && selectedAccountRelatedTab === '46') && getNACHData?.data?.length) && screen !== 'ticket'
                        ?
                            <NachStop glid={glid} stsComments={comments} stsID={stsID} OcrTicket={OcrTicket} updateSTS={updateSTS} descId={descId} getNACHData={getNACHData}/>
                        :
                            <>
                            {uploadedFileNames && <div className='uploaded-files'>{uploadedFileNames}</div>}
                            <div className="comment-btn1 cp">
                                <FileUpload glid={glid} getAttachmentPath={getAttachmentPath} getFiles={getUploadedFiles}/>
                                <span style={{width:'90px', height:'22px', cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("update STS")}>OCR</span>
                                <span style={{width:'162px', height:'22px', cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("Open Ticket")}>Open Ticket</span>
                                <span style={{width:'162px', height:'22px', cursor: disableTktBtn ? "not-allowed" : "pointer",backgroundColor:disableTktBtn && 'lightgray'}} onClick={() => !disableTktBtn && updateSTS("STS Update")}>Update STS</span>
                            </div>
                            <div className="quick_disp_template1">
                                {templateIds.slice(0, 8).map((templateId) => {
                                    const template = templates[templateId];
                                    if (template) {
                                        return (
                                            <p
                                                key={template.id}
                                                onClick={() => applyQuickTemplate(template, true)}
                                                title={template.content}
                                                style={{ width: '43%' }}
                                            >
                                                <>{template.shorthand}</>
                                            </p>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                            </>
                        }
                    </div>
                </div>
        }
        </>
    );
};

export default OcrTemplates;
